import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { List } from '../../list';
import { Heading, Markdown } from '../../markdown';
export function APIServersSection({ api }) {
    const { servers = [] } = api;
    if (typeof servers !== 'object' || !Array.isArray(servers) || servers.length === 0) {
        return null;
    }
    return (_jsxs("div", { children: [_jsx(Heading, { level: 1, children: "Servers" }), _jsx(List, { data: servers, listItem: (server) => (_jsxs("li", { className: "space-y-2 px-[--gutter] py-2", children: [_jsx("h4", { className: "text-xs font-medium leading-6 text-zinc-700 dark:text-zinc-300", children: _jsx("span", { className: "mr-2 font-semibold", children: server.url }) }), server.description && _jsx(Markdown, { content: server.description })] })), listItemKey: (server) => server.url })] }));
}
